export default __webpack_public_path__ + "static/media/radioCheckedIcon.a4902c97.svg";